export function clearLocalStorage(exceptStorageKeys?: string[]): void {
  const exceptStorage = new Map<string, string>()

  exceptStorageKeys?.forEach((storageKey) => {
    const storageValue = localStorage.getItem(storageKey)

    if (storageValue) exceptStorage.set(storageKey, storageValue)
  })

  localStorage.clear()

  exceptStorage.forEach((storageValue, storageKey) => localStorage.setItem(storageKey, storageValue))
}